import React, { useState } from "react";
import ProfileInfo from "../ProfileInfo/ProfileInfo";

import IconList from "../ProfileInfo/Iconlist/IconList";
import UserComponent from "../ProfileInfo/ProfileComponent/UserComponent";
//import CallComponent from "./ProfileComponent/CallComponent";
import LocationComponent from "../ProfileInfo/ProfileComponent/LocationComponent";
import ContactComponent from "../ProfileInfo/ProfileComponent/ContactComponent";
import PreferenceComponent from "../ProfileInfo/ProfileComponent/PreferenceComponent";

const componentMap = {
  UserComponent,
  //CallComponent,
  LocationComponent,
  ContactComponent,
  PreferenceComponent,
  // BusinessDetails,
};

const Settings = ({ isBrand, profileData, handleUserUpdate }) => {
  //  console.log(isBrand, profileData);
  const [selectedComponent, setSelectedComponent] = useState("UserComponent");
  const SelectedComponent = selectedComponent
    ? componentMap[selectedComponent]
    : null;
  return (
    <>
      <div>
        <h1>Settings</h1>

        <div className="xs:w-[430px] bg-white h-auto flex flex-col md:flex-row xs:flex-col mt-4 ">
          <div className="">
            <IconList
              onSelect={setSelectedComponent}
              activeComponent={selectedComponent}
            />
          </div>
          <div className="w-full md:w-[100%] p-3 pt-0 ">
            {SelectedComponent ? (
              <SelectedComponent user={profileData} />
            ) : (
              "Select an option"
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
